import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { apiService } from '../../components/Config/api.service';
import { BOUTON_SECONDAIRE, enveloppeDe } from '../Employee/organigrammeOutils';
import { CARTE, CLASSE_CHAMP } from './departOutils';

/**
 * La checklist d'un départ (Yros/Kavero#62, décision D5) : les lignes fixes
 * créées au lancement et les lignes libres ajoutées par la RH. Elle se coche
 * tant que le départ est lancé ou au STC validé ; clos, elle se lit seulement.
 */
const ETATS_MODIFIABLES = ['lance', 'stc_valide'];

function DepartChecklist({ depart, onDepart }) {
  const { t } = useTranslation();
  const [libelle, setLibelle] = useState('');
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState('');
  const modifiable = ETATS_MODIFIABLES.includes(depart.etat);

  const appeler = async (appel) => {
    setEnCours(true);
    setErreur('');
    const reponse = await enveloppeDe(appel);
    setEnCours(false);
    if (reponse.ok) {
      onDepart(reponse.depart);
      return true;
    }
    setErreur(reponse.message || t('departs.erreurGenerique'));
    return false;
  };

  const ajouter = async (event) => {
    event.preventDefault();
    if (!libelle.trim()) return;
    if (await appeler(() => apiService.ajouterLigneChecklist(depart.id, libelle.trim()))) setLibelle('');
  };

  const lignes = depart.checklist || [];
  const faites = lignes.filter((ligne) => ligne.fait).length;

  return (
    <div className={CARTE} data-testid="depart-checklist">
      <h2 className="text-base font-semibold mb-1">{t('departs.checklist.titre')}</h2>
      <p className="text-xs text-gray-500 mb-3">{t('departs.checklist.avancement', { faites, total: lignes.length })}</p>
      <ul className="space-y-2">
        {lignes.map((ligne) => (
          <li key={ligne.id}>
            <label className="inline-flex items-center gap-2 text-sm">
              <input type="checkbox" data-testid={`depart-ligne-${ligne.id}`} checked={ligne.fait}
                disabled={!modifiable || enCours}
                onChange={(e) => appeler(() => apiService.cocherLigneChecklist(depart.id, ligne.id, e.target.checked))} />
              <span className={ligne.fait ? 'line-through text-gray-500' : ''}>{ligne.libelle}</span>
            </label>
          </li>
        ))}
      </ul>
      {modifiable && (
        <form onSubmit={ajouter} className="mt-3 flex gap-2">
          <input type="text" data-testid="depart-ligne-libre" value={libelle} maxLength={200}
            placeholder={t('departs.checklist.placeholder')} onChange={(e) => setLibelle(e.target.value)}
            className={`${CLASSE_CHAMP} mt-0`} />
          <button type="submit" data-testid="depart-ligne-ajouter" disabled={enCours || !libelle.trim()}
            className={BOUTON_SECONDAIRE}>
            {t('departs.checklist.ajouter')}
          </button>
        </form>
      )}
      {erreur && <p role="alert" className="mt-2 text-sm text-red-700">{erreur}</p>}
    </div>
  );
}

export default DepartChecklist;
